import type { EditorialPage } from "@/src/domain/model/EditorialPage";
import type { EventId } from "@/src/domain/model/Event";
import type {
  ProductReference,
  ProductSpecificationSlug,
} from "@/src/domain/model/Product";

export const pathToAdhesion = "/societaire/adhesion";
export const pathToApproach = "/p/demarche-collective-et-solidaire";
export const pathToApiProxy = "/api";
export const pathToLegalStatus = "/p/mentions-legales";
export const pathToLogout = "/auth/logout";
export const pathToMemberProfile = "/societaire/profil";
export const pathToPrivacyPolicy = "/p/politique-de-confidentialite";
export const pathToProducts = "/produits";
export const pathToSupports = "/p/supports-solidaires";
export const pathToSurveys = "/questionnaire";
export const pathToWhereToFindProducts = "/ou-trouver-les-produits";

export const pathToAdhesionStep = [
  "informations",
  "paiement",
  "confirmation",
].map((step) => `${pathToAdhesion}/${step}`);

export function pathToEditorialPage(editorialPage: EditorialPage): string {
  return `/p/${encodeURIComponent(editorialPage.slug)}`;
}

export function pathToLogin(returnTo?: string): string {
  return `/auth/login${returnTo ? `?returnTo=${encodeURIComponent(returnTo)}` : ""}`;
}

export function pathToProduct(reference: null | ProductReference): string {
  return reference
    ? `${pathToProducts}/${encodeURIComponent(reference.slug)}`
    : pathToProducts;
}

export function pathToSurveyEnd(
  productSpecificationSlug: ProductSpecificationSlug,
): string {
  return `${pathToSurveys}/${encodeURIComponent(productSpecificationSlug)}/fin`;
}

export function pathToSurveyStart(
  productSpecificationSlug: ProductSpecificationSlug,
): string {
  return `${pathToSurveys}/${encodeURIComponent(productSpecificationSlug)}/intro`;
}

export function pathToSurveyVote(
  productSpecificationSlug: ProductSpecificationSlug,
): string {
  return `${pathToSurveys}/${encodeURIComponent(productSpecificationSlug)}/vote`;
}

export function pathToVisio(id: EventId): string {
  return `/societaire/evenements/visios/${encodeURIComponent(id)}`;
}
